import { useCallback } from 'react';

/**
 * Custom hook for smooth scrolling to elements
 * @param offset Offset from the top (default: 80px for fixed nav)
 * @returns scrollToSection function
 */
export const useSmoothScroll = (offset = 80) => {
  const scrollToSection = useCallback(
    (sectionId: string) => {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
    [offset]
  );

  return { scrollToSection };
};
